import React from "react";
import { Container, Row, Col, Card } from "react-bootstrap";
import { FaEnvelope, FaWhatsapp, FaPhoneAlt } from "react-icons/fa";
import CommonNavbar from "../CommonLayout/CommonNavbar";
import CommonFooter from "../CommonLayout/CommonFooter";

const SupportPage = () => {
  return (
    <>
      <CommonNavbar />
      <Container style={{ padding: "30px" }}>
        <h2>Support</h2>
        <div className="mt-4">
          <p>
            If you need assistance, please reach out to our support team through one of the following channels.
          </p>
        </div>
        <Row className="mt-4">
          <Col md={4} className="mb-3">
            <Card className="shadow-sm">
              <Card.Body>
                <Card.Title>
                  <FaEnvelope className="mr-2" /> Email Support
                </Card.Title>
                <br></br>
                <Card.Text>
                  For general inquiries, please email us at:{" "}
                  <a href="mailto:support@psychooncology.online">
                    support@psychooncology.online
                  </a>
                </Card.Text>
              </Card.Body>
            </Card>
          </Col>
          <Col md={4} className="mb-3">
            <Card className="shadow-sm">
              <Card.Body>
                <Card.Title>
                  <FaWhatsapp className="mr-2" /> WhatsApp Support
                </Card.Title>
                <br></br>
                <Card.Text>
                  Chat with our support team on WhatsApp:{" "}
                  <a href="https://wa.me/919545300800" target="_blank" rel="noreferrer">
                    +91 9545 300 800
                  </a>
                </Card.Text>
              </Card.Body>
            </Card>
          </Col>
          <Col md={4} className="mb-3">
            <Card className="shadow-sm">
              <Card.Body>
                <Card.Title>
                  <FaPhoneAlt className="mr-2" /> On Call Support
                </Card.Title>
                <br></br>
                <Card.Text>
                  Speak with a support agent over the phone:{" "}
                  <a href="tel:+919545300800">
                    +91 9545 300 800
                  </a>
                </Card.Text>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>
      <CommonFooter />
    </>
  );
};

export default SupportPage;
